import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { AccordionModule } from 'primeng/accordion';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import {
  FormBuilder,
  ReactiveFormsModule,
  Validators,
  FormGroup,
  FormsModule,
} from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { Select } from 'primeng/select';
import { DialogService } from 'primeng/dynamicdialog';
import {
  InstituicaoEnsinoService,
  PaisService,
  ProvinciaService,
  UnidadeOrganicaService,
  CommunicationService,
  MunicipioService,
} from '@app/features-modules/gestao-bolseiros/components/api/services';
import { ApiService } from '@core/providers/http';
import { CheckboxModule } from 'primeng/checkbox';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { AuthService } from '@core/service/auth.service';
import { FileUpload } from 'primeng/fileupload';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-unidade-organica',
  imports: [
    CommonModule,
    ButtonModule,
    AccordionModule,
    ReactiveFormsModule,
    DialogModule,
    Select,
    InputTextModule,
    FormsModule,
    CheckboxModule,
    CommonModule,
    ReactiveFormsModule,
    ToastModule,
    FileUpload,
  ],
  providers: [
    ApiService,
    PaisService,
    ProvinciaService,
    MunicipioService,
    DialogService,
    UnidadeOrganicaService,
    InstituicaoEnsinoService,
    MessageService,
    AuthService,
  ],
  standalone: true,
  templateUrl: './unidade-organica.component.html',
  styleUrl: './unidade-organica.component.scss',
})
export class UnidadeOrganicaComponent implements OnInit {
  ref = inject(DynamicDialogRef);
  messageService = inject(MessageService);
  unidadeOrganicaForm: FormGroup;
  private fb = inject(FormBuilder);
  private authService = inject(AuthService);
  private instituicaoEnsinoService = inject(InstituicaoEnsinoService);
  config = inject(DynamicDialogConfig);
  instituicaoEnsinoId = this.config.data.instituicaoEnsinoId;
  dadosInstituicao: any;
  TypeOfinstituicao: string = '';
  tipoInstituicaoEnsinoValueEnum: number = 0;
  unidadeOrganica = this.config.data.unidadeOrganica;
  paisService = inject(PaisService);
  provinciaService = inject(ProvinciaService);
  municipioService = inject(MunicipioService);
  unidadeOrganicaService = inject(UnidadeOrganicaService);
  countries: any[] = [];
  provinces: any[] = [];
  municipalities: any[] = [];
  naturezaOptions: any[] = [];
  typeofEducationalInstitution: any[] = [];
  private subscriptions = new Subscription();
  private route = inject(ActivatedRoute);
  isInternalInstitution: boolean = false;
  file: any;
  selectedFile: File | null = null;
  imagePreview: string | ArrayBuffer | null = null;
  private communicationService = inject(CommunicationService);

  // ✅ Flag para suprimir valueChanges durante patch inicial
  private isLoadingDetails = false;

  constructor() {
    this.unidadeOrganicaForm = this.fb.group({
      id: ['0'],
      nome: ['', Validators.required],
      instituicaoEnsinoID: [this.instituicaoEnsinoId, Validators.required],
      paisID: [null],
      provinciaEstadoID: [null, Validators.required],
      ativo: [true],
      tipoInstituicaoEnsinoID: [{ value: null, disabled: true }, Validators.required],
      sigla: ['', [Validators.required, Validators.maxLength(10)]],
      numIdentificacao: [''],
      provinciaID: [''],
      municipioID: ['', Validators.required],
      categoriaInstituicaoEnsinoID: [2, Validators.required],
      endereco: [''],
      telefone: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      natureza: ['', Validators.required],
    });

    this.unidadeOrganicaForm.controls['paisID'].valueChanges.subscribe(
      (value) => {
        if (!value) {
          this.provinces = [];
          return;
        }
        if (this.isLoadingDetails) return;
        this.loadProvinces(value);
      }
    );

    this.unidadeOrganicaForm.controls['provinciaEstadoID'].valueChanges.subscribe(
      (value) => {
        if (!value) {
          this.municipalities = [];
          return;
        }
        // ✅ Ignora durante patch inicial para evitar race condition
        if (this.isLoadingDetails) return;
        this.loadMunicipalities(value);
      }
    );

    this.unidadeOrganicaForm.controls['tipoInstituicaoEnsinoID'].valueChanges.subscribe(
      (value) => {
        this.isInternalInstitution = value === 0;
        if (!this.isInternalInstitution) {
          ['nome'].forEach((control) => {
            this.unidadeOrganicaForm.get(control)?.enable();
          });
        }
      }
    );

    this.countries = this.config.data.countries;
    this.provinces = this.config.data.provinces;
    this.municipalities = this.config.data.municipalities;
    this.typeofEducationalInstitution = this.config.data.typeofEducationalInstitution;
    this.naturezaOptions = this.config.data.naturezaOptions;
    this.instituicaoEnsinoId = this.config.data.instituicaoEnsinoId;

    this.subscriptions.add(
      this.communicationService.provinces$.subscribe((provinces) => {
        this.provinces = provinces;
      })
    );
    this.subscriptions.add(
      this.communicationService.municipalities$.subscribe((municipalities) => {
        this.municipalities = municipalities;
      })
    );
  }

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      const id = params.get('id');
      this.InsID = id;
    });

    this.loadCountries();

    // ✅ loadUnidadeOrganicaDetails só corre APÓS loadInstitutionDetails terminar
    if (this.config.data.unidadeOrganica && this.config.data.unidadeOrganica.id) {
      this.loadInstitutionDetails(this.InsID, () => {
        this.loadUnidadeOrganicaDetails(this.config.data.unidadeOrganica);
      });
    } else {
      this.loadInstitutionDetails(this.InsID);
    }
  }

  InsID: any | undefined;

  loadCountries() {
    this.paisService.list({
        page: 1,
        pageSize: 9999,
    }).subscribe((response) => {
      this.countries = response;
    });
  }

  loadProvinces(countryId: string) {
    this.provinciaService.list(countryId).subscribe((response) => {
      this.provinces = response;
    });
  }

  loadMunicipalities(provinceId: string, preSelectId?: any) {
    this.municipioService.list(provinceId).subscribe((response) => {
      this.municipalities = response;

      // ✅ Aplica município apenas após a lista estar disponível
      if (preSelectId) {
        this.unidadeOrganicaForm.patchValue({ municipioID: preSelectId });
      }
    });
  }

  loadUnidadeOrganicaDetails(unidadeOrganica: any): void {
    const provinciaId = unidadeOrganica.provinciaEstadoID || unidadeOrganica.provinciaID;
    const municipioId = unidadeOrganica.municipioID;

    this.isLoadingDetails = true;

    this.unidadeOrganicaForm.patchValue({
      id: unidadeOrganica.id,
      tipoInstituicaoEnsinoID: this.TypeOfinstituicao,
      nome: unidadeOrganica.nome,
      natureza: unidadeOrganica.naturezaValueEnum,
      instituicaoEnsinoID: unidadeOrganica.instituicaoEnsinoID || this.instituicaoEnsinoId,
      paisID: unidadeOrganica.paisID,
      provinciaEstadoID: provinciaId,
      numIdentificacao: unidadeOrganica.numIdentificacao,
      ativo: unidadeOrganica.ativo ?? true,
      email: unidadeOrganica.email,
      telefone: unidadeOrganica.telefone,
      sigla: unidadeOrganica.sigla,
      endereco: unidadeOrganica.endereco,
    });

    this.isLoadingDetails = false;

    if (unidadeOrganica.paisID) {
      this.provinciaService.list(unidadeOrganica.paisID).subscribe((provinces) => {
        this.provinces = provinces;

        if (provinciaId) {
          this.municipioService.list(provinciaId).subscribe((municipalities) => {
            this.municipalities = municipalities;

            // ✅ Debug — confirma se o ID existe na lista
            const found = municipalities.find((m: any) => m.id === municipioId || m.id === +municipioId);
            console.log('municipioId a aplicar:', municipioId, typeof municipioId);
            console.log('encontrado na lista:', found);
            console.log('lista de municípios:', municipalities.map((m: any) => ({ id: m.id, tipo: typeof m.id })));

            // ✅ Garante que o tipo bate certo (string vs number)
            const municipioIdFinal = typeof municipalities[0]?.id === 'number' ? +municipioId : String(municipioId);

            this.unidadeOrganicaForm.patchValue({ municipioID: municipioIdFinal });

            // ✅ Força deteção de mudanças após patch
            this.unidadeOrganicaForm.get('municipioID')?.updateValueAndValidity();
          });
        }
      });
    }
  }

  loadInstitutionDetails(id: number, onComplete?: () => void): void {
    this.instituicaoEnsinoService.show(id).subscribe((data: any) => {
      this.dadosInstituicao = data;
      this.TypeOfinstituicao = data.tipoInstituicao;
      const tipoId = data.tipoInstituicaoEnsinoValueEnum;

      const tipoMapeado =
        this.typeofEducationalInstitution.find(
          (item) => item.designacao == data?.tipoInstituicao
        )?.value ?? 0;

      this.unidadeOrganicaForm.patchValue({
        tipoInstituicaoEnsinoID: tipoId || tipoMapeado,
      });

      this.unidadeOrganicaForm.get('tipoInstituicaoEnsinoID')?.disable();

      // ✅ Só chama o próximo passo depois de tudo estar pronto
      onComplete?.();
    });
  }

  save(): void {
    if (!this.unidadeOrganicaForm.valid) {
      this.unidadeOrganicaForm.markAllAsTouched();
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'Por favor, preencha todos os campos obrigatórios.',
        life: 3000,
      });
      return;
    }

    const rawData = this.unidadeOrganicaForm.getRawValue();
    const formData = new FormData();
    formData.append('ID', rawData.id);
    formData.append('Nome', rawData.nome);
    formData.append('TipoInstituicao', rawData.tipoInstituicaoEnsinoID);
    formData.append('Sigla', rawData.sigla);
    formData.append('NumIdentificacao', rawData.numIdentificacao ?? '');
    formData.append('InstituicaoPaiID', this.instituicaoEnsinoId);
    formData.append('paisID', rawData.paisID ?? '');
    formData.append('ProvinciaID', rawData.provinciaID || rawData.provinciaEstadoID || 4);
    formData.append('MunicipioID', rawData.municipioID);
    formData.append('Endereco', rawData.endereco ?? '');
    formData.append('Telefone', rawData.telefone);
    formData.append('Email', rawData.email);
    formData.append('Natureza', rawData.natureza);
    formData.append('IsActive', rawData.ativo);

    if (this.selectedFile) {
      formData.append('Foto', this.selectedFile, this.selectedFile.name);
    }

    const toEdit = rawData.id && rawData.id !== '0';
    const operation$ = toEdit
      ? this.instituicaoEnsinoService.update(formData, rawData.id)
      : this.instituicaoEnsinoService.store(formData);

    operation$.subscribe({
      next: (response: any) => {
        if (response?.data === false) {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: response?.retorno?.mensagem || `Erro ao ${toEdit ? 'actualizar' : 'criar'} Unidade Orgânica.`,
            life: 3000,
          });
          return;
        }

        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: `Unidade Orgânica ${toEdit ? 'actualizada' : 'criada'} com sucesso!`,
          life: 3000,
        });

        setTimeout(() => this.ref.close(response), 1000);
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: error.error?.retorno?.mensagem || `Erro ao ${toEdit ? 'actualizar' : 'criar'} Unidade Orgânica.`,
          life: 3000,
        });
      },
    });
  }

  cancel() {
    this.ref.close();
  }

  choose(event: any, callback: () => void) {
    callback();
  }

  onSelectedFiles(event: { currentFiles: any }) {
    this.file = event.currentFiles[0];

    const maxSizeMB = 2;
    if (this.file.size > maxSizeMB * 1024 * 1024) {
      this.messageService.add({
        severity: 'error',
        summary: 'Imagem muito grande',
        detail: `A imagem deve ter no máximo ${maxSizeMB}MB.`,
        life: 3000,
      });
      return;
    }

    if (!this.file.type.startsWith('image/')) {
      this.messageService.add({
        severity: 'error',
        summary: 'Formato inválido',
        detail: 'Apenas imagens são permitidas.',
        life: 3000,
      });
      return;
    }

    this.selectedFile = this.file;
    this.unidadeOrganicaForm.patchValue({ Foto: this.file });

    const reader = new FileReader();
    reader.onload = () => {
      this.imagePreview = reader.result as string;
    };
    reader.readAsDataURL(this.file);
  }

  searchNif() {
    this.authService
      .getInfoByNif(this.unidadeOrganicaForm.controls['numIdentificacao'].value as string)
      .subscribe((result) => {
        if (result.retorno.codigo === 200) {
          const moradaPrincipal = result.data.moradaPrincipal || {};
          const isCompany = !!result.data.nomeColectivo;
          const isIndividual = !!result.data.nomeContribuinte;
          const email =
            result.data.listaReprLegal?.reprLegal[0]?.emailRepLegal ||
            result.data.listaEmail?.email[0];
          const telefone = result.data.contactoPrincipal.numeroContacto as string;
          const endereco = `${moradaPrincipal.municipio ?? ''} ${moradaPrincipal.bairro ?? ''} ${moradaPrincipal.morada ?? ''}`.trim();

          if (isCompany) {
            this.unidadeOrganicaForm.patchValue({ nome: result.data.nomeColectivo, endereco, telefone, email });
          } else if (isIndividual) {
            this.unidadeOrganicaForm.patchValue({ nome: result.data.nomeContribuinte, endereco, telefone, email: email || '' });
            this.unidadeOrganicaForm.controls['email'].enable();
          }

          if (!email) this.unidadeOrganicaForm.controls['email'].enable();
          if (!telefone) this.unidadeOrganicaForm.controls['telefone'].enable();
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: 'Não foi possível encontrar informações pelo NIF fornecido.',
            life: 3000,
          });
        }
      });
  }
}